import axios from 'axios';
import { getStorefrontStoreId } from './api';
import { getApiBaseUrl } from '../lib/storefront/storeBootstrap';

const API_BASE_URL = getApiBaseUrl();

const createApiError = (error) => {
    const message = error.response?.data?.message || error.message || 'Request failed';
    const apiError = new Error(message);
    apiError.status = error.response?.status;
    apiError.data = error.response?.data;
    apiError.originalError = error;
    return apiError;
};

const getAuthConfig = () => {
    const token = localStorage.getItem('token');
    const storeId = getStorefrontStoreId();
    return {
        headers: {
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
            ...(storeId ? { 'X-Store-Id': storeId } : {}),
        },
    };
};

export const getWishlist = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/appUser/product-wishlist`, getAuthConfig());
        return response.data;
    } catch (error) {
        throw createApiError(error);
    }
};

export const addWishlistItem = async (productId) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/api/appUser/product-wishlist/${productId}`,
            {},
            getAuthConfig()
        );
        return response.data;
    } catch (error) {
        throw createApiError(error);
    }
};

export const removeWishlistItem = async (productId) => {
    try {
        const response = await axios.delete(
            `${API_BASE_URL}/api/appUser/product-wishlist/${productId}`,
            getAuthConfig()
        );
        return response.data;
    } catch (error) {
        throw createApiError(error);
    }
};

export const clearWishlistItems = async () => {
    try {
        const response = await axios.delete(`${API_BASE_URL}/api/appUser/product-wishlist`, getAuthConfig());
        return response.data;
    } catch (error) {
        throw createApiError(error);
    }
};
